import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { ApiUrl } from "./ApiUrl";
import { useLanguage } from "./languageContext";
import translations from "./translation.json";
import Select from "react-select";
import * as Yup from "yup";
import { ErrorMessage, Field, Form, Formik } from "formik";
import Loader from "./loader";
import Dropzone from "react-dropzone";
import CreateGroup from "./createGroup";
import { provincesOptions } from "./constants/userTypes";

const AddDealershipModal = ({
  // groupList,
  // setGroupList,
  setDealerTrigger,
  setIsLoading,
  isDarkMode,
  setNewDealership = () => { },
  dealerships,
  setSelectedDealership = () => { },
  users,
  quickAdd = false,

}) => {
  const token = localStorage.getItem("token");
  const { language } = useLanguage();
  const [brands, setBrands] = useState();
  const [selected, setSelected] = useState(null);
  const [repOptions, setRepOptions] = useState([]);
  const [groupOptions, setGroupOptions] = useState([]);
  const [groupList, setGroupList] = useState(null);

  const [loading, setLoading] = useState(false);
  var button = document.getElementById("closebtn3");
  var currentUrl = window.location.href;
  const [selectedGroup, setSelectedGroup] = useState(null);
  // console.log(currentUrl.includes("events"));
  const [isCreateGroupOpen, setIsCreateGroupOpen] = useState(false);


  // useEffect(() => {
  //   const getGroup = async () => {
  //     try {
  //       const res = await fetch(ApiUrl + "/api/user/get-group", {
  //         method: "GET",
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${token}`,
  //         },
  //       });

  //       const data = await res.json();

  //       if (data.status === "success") {
  //         const groupOptions = data?.list_of_group?.map((group) => ({
  //           label: group.name,
  //           value: group.id,
  //         }));
  //         setGroupList(groupOptions);
  //       } else {
  //         // toast.error(data.message);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching dealerships:", error);
  //       // Handle error or show a toast if needed
  //     }
  //   };
  //   getGroup();
  // }, [token]);
  
  useEffect(() => {
  const modalEl = document.getElementById("myModalCon");

  const handleShow = async () => {
    try {
      const res = await fetch(ApiUrl + "/api/user/get-group", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await res.json();

      if (data.status === "success") {
        const groupOptions = data?.list_of_group?.map((group) => ({
          label: group.name,
          value: group.id,
        }));
        setGroupList(groupOptions);
      } else {
        console.warn("Failed to fetch groups:", data.message);
      }
    } catch (error) {
      console.error("Error fetching groups:", error);
    }
  };

  // attach event listener
  if (modalEl) {
    modalEl.addEventListener("shown.bs.modal", handleShow);
  }

  // cleanup
  return () => {
    if (modalEl) {
      modalEl.removeEventListener("shown.bs.modal", handleShow);
    }
  };
}, [token]);


  useEffect(() => {
    const getGroup = async () => {
      try {
        const res = await fetch(ApiUrl + "/api/user/get-group", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        const data = await res.json();

        if (data.status === "success") {
          const groupOptions = data?.list_of_group?.map((group) => ({
            label: group.name,
            value: group.id,
          }));
          setGroupList(groupOptions);
        } else {
          // toast.error(data.message);
        }
      } catch (error) {
        console.error("Error fetching dealerships:", error);
        // Handle error or show a toast if needed
      }
    };
    getGroup();
  }, [token]);

  //  useEffect(() => {
  //    setGroupOptions(groupList)
  //   }, [groupList]);

  const initialData = {
    name: "",
    country: "",
    state: "",
    city: "",
    address: "",
    postal_code: "",
    timezone: "",
    phone_number: "",
    primary_contact: "",
    activeX_key: "",
    activeX_first_name: "",
    activeX_last_name: "",
    group_id: "",
    representative_id: "",
    brand_id: "",
    logo: "",
    crm_link: "",
  };
  const validationSchema = Yup.object().shape({
    name: Yup.string().required(
      translations.quickCreationModal.validationsText.dealershipText[language]
    ),
    // logo: Yup.mixed()
    //   .test(
    //     "fileType",
    //     `${translations.quickCreationModal.validationsText.logoformat[language]}`,
    //     (value) => {
    //       return (
    //         value &&
    //         ["image/jpeg", "image/webp", "image/png", "image/jpg"].includes(
    //           value.type
    //         )
    //       );
    //     }
    //   )
    //   .required(translations.quickCreationModal.validationsText.logo[language]),
    // country: Yup.string().required(
    //   translations.quickCreationModal.validationsText.country[language]
    // ),
    // state: Yup.string().required(
    //   translations.quickCreationModal.validationsText.state[language]
    // ),
    // city: Yup.string().required(
    //   translations.quickCreationModal.validationsText.city[language]
    // ),
    // address: Yup.string().required(
    //   translations.quickCreationModal.validationsText.address[language]
    // ),
    // postal_code: Yup.number().required(
    //   translations.forms.validationTranslations.postal_code[language]
    // ),
    // timezone: Yup.string().required(
    //   translations.quickCreationModal.validationsText.timezone[language]
    // ),
    // phone_number: Yup.string().required(
    //   translations.quickCreationModal.validationsText.phoneNumber[language]
    // ),
    // primary_contact: Yup.string().required(
    //   translations.quickCreationModal.validationsText.primaryContact[language]
    // ),
    // group_id: Yup.string().required(
    //   translations.quickCreationModal.validationsText.Group[language]
    // ),
    representative_id: Yup.string().required(
      translations.forms.validationTranslations.representatives[language]
    ),
    brand_id: Yup.string().required(
      translations.quickCreationModal.validationsText.brandText[language]
    ), //.required('Dealership Name is required'),
    // crm_link: Yup.string().required(
    //   translations.quickCreationModal.validationsText.crmLink[language]
    // ),
    activeX_key: Yup.string(),

    activeX_first_name: Yup.string().when("activeX_key", {
      is: (val) => val && val.trim() !== "",
      then: (schema) => schema.required(translations.appointments.validations.firstName[language]),
      otherwise: (schema) => schema,
    }),

    activeX_last_name: Yup.string().when("activeX_key", {
      is: (val) => val && val.trim() !== "",
      then: (schema) => schema.required(translations.appointments.validations.lastName[language]),
      otherwise: (schema) => schema,
    }),
  });


  useEffect(() => {
    const getBrands = async () => {
      try {
        const res = await fetch(ApiUrl + "/api/user/get-brands", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        const data = await res.json();

        if (data.status === "success") {
          setBrands(data.list_of_brands);
        } else {
          toast.error(data.message);
        }
      } catch (error) {
        console.error("Error fetching dealerships:", error);
        // Handle error or show a toast if needed
      }
    };
    const fetchUsers = async () => {
      try {
        const res = await fetch(
          ApiUrl + "/api/user/representative",

          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        // console.log("Get users res: ", res);
        const data = await res.json();
        // console.log("Get users data: ", data)
        // console.log(result)
        if (data.status === "success") {
          const rep =
            data?.representatives &&
            data?.representatives.length > 0 &&
            data?.representatives.map((user) => ({
              value: user.id,
              label: user.name,
            }));
          setRepOptions(rep);

          // Set state with new data
        } else {
          toast.error(data.message);
        }
      } catch (err) {
        toast.error(translations.alertMessages.wentWrong[language]);
      } finally {
      }
    };

    if (token) {
      getBrands();
      fetchUsers();
    }
  }, [token]);

  const handleSubmit = async (values, { resetForm }, error) => {
    try {
      setLoading(true);
      const formdata = new FormData();
      Object.keys(values).forEach((key) => {
        // formdata.append(key, values[key]);
        if (key === "group_id") {
          formdata.append(key, selectedGroup || values[key] || "");
        } else {
          formdata.append(key, values[key]);
        }
      });
      const res = await fetch(ApiUrl + "/api/user/create-dealership", {
        method: "POST",
        headers: {
          // "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: formdata,
      });
      const data = await res.json();
      if (data.status === "success") {

        resetForm();
        setSelected(null);
        setSelectedDealership(data.dealer_ship.id);
        button.click();
        toast.success(data.message);
        if (data?.validate_active_x_key == "Invalid Token") {
          toast.error(translations.forms.invalid_Token_message[language]);

        }
        setDealerTrigger((prevState) => {
          return !prevState;
        });
        // setNewDealership({
        //   label: data.dealer_ship.name,
        //   value: data.dealer_ship.id,
        // });
      } else {
        toast.error(translations.alertMessages.wentWrong[language]);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error(translations.alertMessages.wentWrong[language]);
    }
  };

  const brandOptions =
    brands &&
    brands.length > 0 &&
    brands.map((brand) => ({
      value: brand.id,
      label: brand.name,
    }));

  const openCustomModal = () => {
    // Hide the Bootstrap modal
    const bootstrapModalEl = document.getElementById("myModalCon");
    if (bootstrapModalEl && window.bootstrap) {
      const instance = window.bootstrap.Modal.getInstance(bootstrapModalEl);
      instance?.hide();
    }
    setIsCreateGroupOpen(true); // open your custom modal
  };

  const closeCustomModal = () => {
    setIsCreateGroupOpen(false);

    // Optionally re-open the Bootstrap modal
    const bootstrapModalEl = document.getElementById("myModalCon");
    if (bootstrapModalEl && window.bootstrap) {
      const instance = new window.bootstrap.Modal(bootstrapModalEl);
      instance.show();
    }
  };


  return (
    <>
      <div id="myModalCon" class="modal fade" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered modal-fullscreen">
          <div class="modal-content">
            <Formik
              initialValues={initialData}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
              id="creationsuccess"
            >
              {({ errors, values, setValues, resetForm, setFieldValue }) => (
                <Form>
                  <div
                    class="modal-header"
                    style={{
                      borderBottom: isDarkMode
                        ? "1px solid #495057"
                        : "1px solid #dee2e6",
                    }}
                  >
                    <h3 style={{ color: "#000000" }}>
                      🗂 {translations["commonWords"].addDealership[language]}
                    </h3>
                    <button
                      type="button"
                      class="btn-close"
                      data-bs-dismiss="modal"
                      onClick={() => button.click()}
                      style={{
                        filter: isDarkMode ? "invert(1)" : "none", // Invert the color in dark mode
                        color: isDarkMode
                          ? "#ffffff"
                          : "rgb(255, 255, 255) !important",
                      }}
                      id="closeModalBtn"
                    ></button>
                  </div>
                  <div
                    className="modal-body"
                    style={{
                      // height: "300px",
                      overflowY: "scroll",
                    }}
                  >
                    <div className="row">
                      <div className="col-6" style={{ paddingRight: "0px" }}>
                        <label for="inputadddealership" class="form-label">
                          {translations["commonWords"].dealership[language]}
                        </label>
                        <div class="mb-3">
                          <Field
                            name="name"
                            type="text"
                            className="form-control"
                            id="inputadddealership"
                            style={{
                              backgroundColor: isDarkMode ? "transparent" : "",
                              color: isDarkMode ? "#ffffff" : "#000000",
                              border: isDarkMode
                                ? "1px solid #495057"
                                : "1px solid #dee2e6",
                            }}
                            placeholder={
                              translations["commonFields"].name[language]
                            }
                          />
                          <ErrorMessage
                            name="name"
                            component="div"
                            className="error text-danger"
                          />
                        </div>
                      </div>
                      <div className="col-6">
                        <label for="inputadddealership" class="form-label">
                          {translations.quickCreationModal.country[language]}
                        </label>
                        <div className="mb-3">
                          {/* <Field
                          name="country"
                          render={({ field, form }) => (
                            <Select
                              className="selectpicker"
                              aria-labelledby="dealership-name-quick"
                              // isClearable
                              // options={packageOptions}
                              placeholder={
                                translations["dropdown"].select[language]
                              }
                              isSearchable
                              // value={
                              //   (packageOptions &&
                              //     packageOptions.length > 0 &&
                              //     packageOptions.find(
                              //       (option) => option.value === field.value
                              //     )) || {
                              //     value: "",
                              //     label:
                              //       translations["dropdown"].select[language],
                              //   }
                              // }
                              onChange={(selectedOption) =>
                                form.setFieldValue(
                                  field.name,
                                  selectedOption.value
                                )
                              }
                              maxMenuHeight={"120px"}
                              styles={{
                                input: (provided) => ({
                                  ...provided,
                                  color: isDarkMode ? "#ffffff" : "black", // Color of the text when typing
                                }),
                                control: (provided, state) => ({
                                  ...provided,
                                  backgroundColor: isDarkMode
                                    ? "transparent"
                                    : "white",
                                  border: state.isFocused
                                    ? "1px solid #80bdff"
                                    : isDarkMode
                                    ? "1px solid #495057"
                                    : "1px solid #dee2e6", // Adjust the border color for focus
                                  boxShadow: state.isFocused
                                    ? "0 0 0 0.2rem rgba(0, 123, 255, 0.25)"
                                    : "none", // Bootstrap's box shadow for focus
                                  borderRadius: ".45rem",
                                }),
                                valueContainer: (provided) => ({
                                  ...provided,
                                  padding: "0.18rem 0.55rem", // Bootstrap's padding for the value container
                                }),
                                indicatorSeparator: (provided) => ({
                                  ...provided,
                                  display: "none", // Hide the indicator separator
                                }),
                                dropdownIndicator: (provided) => ({
                                  ...provided,
                                  padding: "0.375rem 0.75rem", // Bootstrap's padding for the dropdown indicator
                                  color: isDarkMode ? "#ffffff" : "#868686",
                                }),
                                menu: (provided) => ({
                                  ...provided,
                                  color: isDarkMode ? "#ffffff" : "black",
                                  backgroundColor: isDarkMode
                                    ? "#1f2023"
                                    : "white",
                                  margin: "0", // Remove default margin
                                }),
                                placeholder: (provided) => ({
                                  ...provided,
                                  color: isDarkMode ? "#ffffff" : "#333333", // Specify your desired color for the placeholder
                                  // Additional styles for placeholder
                                }),
                                singleValue: (provided) => ({
                                  ...provided,
                                  color: isDarkMode ? "#ffffff" : "black",
                                }),
                                option: (provided, state) => ({
                                  ...provided,
                                  color: isDarkMode ? "#ffffff" : "black",
                                  backgroundColor: state.isHovered
                                    ? "#80bdff"
                                    : isDarkMode
                                    ? "#1f2023"
                                    : "white",
                                  ":hover": {
                                    backgroundColor: isDarkMode
                                      ? "#34DBB4"
                                      : "#34DBB4",
                                  },
                                }),
                              }}
                            />
                          )}
                        /> */}
                          <Field
                            name="country"
                            type="text"
                            className="form-control"
                            id="inputadddealership"
                            style={{
                              backgroundColor: isDarkMode ? "transparent" : "",
                              color: isDarkMode ? "#ffffff" : "#000000",
                              border: isDarkMode
                                ? "1px solid #495057"
                                : "1px solid #dee2e6",
                            }}
                            placeholder={
                              translations.quickCreationModal.country[language]
                            }
                          />
                          <ErrorMessage
                            name="country"
                            component="div"
                            className="error text-danger"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-6" style={{ paddingRight: "0px" }}>
                        <label for="inputadddealership" class="form-label">
                          {translations.quickCreationModal.state[language]}
                        </label>
                        <div className="mb-3">
                          {/* <Field
                          name="state"
                          render={({ field, form }) => (
                            <Select
                              className="selectpicker"
                              aria-labelledby="dealership-name-quick"
                              // isClearable
                              // options={packageOptions}
                              placeholder={
                                translations["dropdown"].select[language]
                              }
                              isSearchable
                              // value={
                              //   (packageOptions &&
                              //     packageOptions.length > 0 &&
                              //     packageOptions.find(
                              //       (option) => option.value === field.value
                              //     )) || {
                              //     value: "",
                              //     label:
                              //       translations["dropdown"].select[language],
                              //   }
                              // }
                              onChange={(selectedOption) =>
                                form.setFieldValue(
                                  field.name,
                                  selectedOption.value
                                )
                              }
                              maxMenuHeight={"120px"}
                              styles={{
                                input: (provided) => ({
                                  ...provided,
                                  color: isDarkMode ? "#ffffff" : "black", // Color of the text when typing
                                }),
                                control: (provided, state) => ({
                                  ...provided,
                                  backgroundColor: isDarkMode
                                    ? "transparent"
                                    : "white",
                                  border: state.isFocused
                                    ? "1px solid #80bdff"
                                    : isDarkMode
                                    ? "1px solid #495057"
                                    : "1px solid #dee2e6", // Adjust the border color for focus
                                  boxShadow: state.isFocused
                                    ? "0 0 0 0.2rem rgba(0, 123, 255, 0.25)"
                                    : "none", // Bootstrap's box shadow for focus
                                  borderRadius: ".45rem",
                                }),
                                valueContainer: (provided) => ({
                                  ...provided,
                                  padding: "0.18rem 0.55rem", // Bootstrap's padding for the value container
                                }),
                                indicatorSeparator: (provided) => ({
                                  ...provided,
                                  display: "none", // Hide the indicator separator
                                }),
                                dropdownIndicator: (provided) => ({
                                  ...provided,
                                  padding: "0.375rem 0.75rem", // Bootstrap's padding for the dropdown indicator
                                  color: isDarkMode ? "#ffffff" : "#868686",
                                }),
                                menu: (provided) => ({
                                  ...provided,
                                  color: isDarkMode ? "#ffffff" : "black",
                                  backgroundColor: isDarkMode
                                    ? "#1f2023"
                                    : "white",
                                  margin: "0", // Remove default margin
                                }),
                                placeholder: (provided) => ({
                                  ...provided,
                                  color: isDarkMode ? "#ffffff" : "#333333", // Specify your desired color for the placeholder
                                  // Additional styles for placeholder
                                }),
                                singleValue: (provided) => ({
                                  ...provided,
                                  color: isDarkMode ? "#ffffff" : "black",
                                }),
                                option: (provided, state) => ({
                                  ...provided,
                                  color: isDarkMode ? "#ffffff" : "black",
                                  backgroundColor: state.isHovered
                                    ? "#80bdff"
                                    : isDarkMode
                                    ? "#1f2023"
                                    : "white",
                                  ":hover": {
                                    backgroundColor: isDarkMode
                                      ? "#34DBB4"
                                      : "#34DBB4",
                                  },
                                }),
                              }}
                            />
                          )}
                        /> */}
                          {/* <Field
                            name="state"
                            type="text"
                            className="form-control"
                            id="inputadddealership"
                            style={{
                              backgroundColor: isDarkMode ? "transparent" : "",
                              color: isDarkMode ? "#ffffff" : "#000000",
                              border: isDarkMode
                                ? "1px solid #495057"
                                : "1px solid #dee2e6",
                            }}
                            placeholder={
                              translations.quickCreationModal.state[language]
                            }
                          /> */}
                          <Field
                           name="state"
                           render={({ field, form }) => (
                             <Select
                               className="selectpicker"
                               aria-labelledby="dealership-name-quick"
                               options={provincesOptions} // your province options
                               placeholder={translations.quickCreationModal.state[language]}
                               isSearchable
                               value={
                                 (provincesOptions &&
                                   provincesOptions.length > 0 &&
                                   provincesOptions.find(
                                     (option) => option.value === field.value
                                   )) || {
                                   value: "",
                                   label: translations.quickCreationModal.state[language],
                                 }
                               }
                               onChange={(selectedOption) => {
                                 form.setFieldValue(field.name, selectedOption.value);
                               }}
                               maxMenuHeight={180}
                               styles={{
                                 input: (provided) => ({
                                   ...provided,
                                   color: isDarkMode ? "#ffffff" : "black",
                                 }),
                                 control: (provided, state) => ({
                                   ...provided,
                                   backgroundColor: isDarkMode ? "transparent" : "white",
                                   border: state.isFocused
                                     ? "1px solid #80bdff"
                                     : isDarkMode
                                       ? "1px solid #495057"
                                       : "1px solid #dee2e6",
                                   boxShadow: state.isFocused
                                     ? "0 0 0 0.2rem rgba(0, 123, 255, 0.25)"
                                     : "none",
                                   borderRadius: ".45rem",
                                 }),
                                 valueContainer: (provided) => ({
                                   ...provided,
                                   padding: "0.18rem 0.55rem",
                                 }),
                                 indicatorSeparator: (provided) => ({
                                   ...provided,
                                   display: "none",
                                 }),
                                 dropdownIndicator: (provided) => ({
                                   ...provided,
                                   padding: "0.375rem 0.75rem",
                                   color: isDarkMode ? "#ffffff" : "#868686",
                                 }),
                                 menu: (provided) => ({
                                   ...provided,
                                   color: isDarkMode ? "#ffffff" : "black",
                                   backgroundColor: isDarkMode ? "#1f2023" : "white",
                                   margin: 0,
                                 }),
                                 placeholder: (provided) => ({
                                   ...provided,
                                   color: isDarkMode ? "#ffffff" : "#333333",
                                 }),
                                 singleValue: (provided) => ({
                                   ...provided,
                                   color: isDarkMode ? "#ffffff" : "black",
                                 }),
                                 option: (provided, state) => ({
                                   ...provided,
                                   color: isDarkMode ? "#ffffff" : "black",
                                   backgroundColor: state.isFocused
                                     ? "#80bdff"
                                     : isDarkMode
                                       ? "#1f2023"
                                       : "white",
                                   ":hover": {
                                     backgroundColor: isDarkMode ? "#48cae4" : "#48cae4",
                                   },
                                 }),
                               }}
                             />
                           )}
                         />
                          <ErrorMessage
                            name="state"
                            component="div"
                            className="error text-danger"
                          />
                        </div>
                      </div>
                      <div className="col-6">
                        <label for="inputadddealership" class="form-label">
                          {translations.quickCreationModal.city[language]}
                        </label>
                        <div className="mb-3">
                          {/* <Field
                          name="city"
                          render={({ field, form }) => (
                            <Select
                              className="selectpicker"
                              aria-labelledby="dealership-name-quick"
                              // isClearable
                              // options={packageOptions}
                              placeholder={
                                translations["dropdown"].select[language]
                              }
                              isSearchable
                              // value={
                              //   (packageOptions &&
                              //     packageOptions.length > 0 &&
                              //     packageOptions.find(
                              //       (option) => option.value === field.value
                              //     )) || {
                              //     value: "",
                              //     label:
                              //       translations["dropdown"].select[language],
                              //   }
                              // }
                              onChange={(selectedOption) =>
                                form.setFieldValue(
                                  field.name,
                                  selectedOption.value
                                )
                              }
                              maxMenuHeight={"120px"}
                              styles={{
                                input: (provided) => ({
                                  ...provided,
                                  color: isDarkMode ? "#ffffff" : "black", // Color of the text when typing
                                }),
                                control: (provided, state) => ({
                                  ...provided,
                                  backgroundColor: isDarkMode
                                    ? "transparent"
                                    : "white",
                                  border: state.isFocused
                                    ? "1px solid #80bdff"
                                    : isDarkMode
                                    ? "1px solid #495057"
                                    : "1px solid #dee2e6", // Adjust the border color for focus
                                  boxShadow: state.isFocused
                                    ? "0 0 0 0.2rem rgba(0, 123, 255, 0.25)"
                                    : "none", // Bootstrap's box shadow for focus
                                  borderRadius: ".45rem",
                                }),
                                valueContainer: (provided) => ({
                                  ...provided,
                                  padding: "0.18rem 0.55rem", // Bootstrap's padding for the value container
                                }),
                                indicatorSeparator: (provided) => ({
                                  ...provided,
                                  display: "none", // Hide the indicator separator
                                }),
                                dropdownIndicator: (provided) => ({
                                  ...provided,
                                  padding: "0.375rem 0.75rem", // Bootstrap's padding for the dropdown indicator
                                  color: isDarkMode ? "#ffffff" : "#868686",
                                }),
                                menu: (provided) => ({
                                  ...provided,
                                  color: isDarkMode ? "#ffffff" : "black",
                                  backgroundColor: isDarkMode
                                    ? "#1f2023"
                                    : "white",
                                  margin: "0", // Remove default margin
                                }),
                                placeholder: (provided) => ({
                                  ...provided,
                                  color: isDarkMode ? "#ffffff" : "#333333", // Specify your desired color for the placeholder
                                  // Additional styles for placeholder
                                }),
                                singleValue: (provided) => ({
                                  ...provided,
                                  color: isDarkMode ? "#ffffff" : "black",
                                }),
                                option: (provided, state) => ({
                                  ...provided,
                                  color: isDarkMode ? "#ffffff" : "black",
                                  backgroundColor: state.isHovered
                                    ? "#80bdff"
                                    : isDarkMode
                                    ? "#1f2023"
                                    : "white",
                                  ":hover": {
                                    backgroundColor: isDarkMode
                                      ? "#34DBB4"
                                      : "#34DBB4",
                                  },
                                }),
                              }}
                            />
                          )}
                        /> */}
                          <Field
                            name="city"
                            type="text"
                            className="form-control"
                            id="inputadddealership"
                            style={{
                              backgroundColor: isDarkMode ? "transparent" : "",
                              color: isDarkMode ? "#ffffff" : "#000000",
                              border: isDarkMode
                                ? "1px solid #495057"
                                : "1px solid #dee2e6",
                            }}
                            placeholder={
                              translations.quickCreationModal.city[language]
                            }
                          />
                          <ErrorMessage
                            name="city"
                            component="div"
                            className="error text-danger"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-6" style={{ paddingRight: "0px" }}>
                        <label for="inputadddealership" class="form-label">
                          {translations.quickCreationModal.address[language]}
                        </label>
                        <div className="mb-3">
                          {/* <Field
                          name="city"
                          render={({ field, form }) => (
                            <Select
                              className="selectpicker"
                              aria-labelledby="dealership-name-quick"
                              // isClearable
                              // options={packageOptions}
                              placeholder={
                                translations["dropdown"].select[language]
                              }
                              isSearchable
                              // value={
                              //   (packageOptions &&
                              //     packageOptions.length > 0 &&
                              //     packageOptions.find(
                              //       (option) => option.value === field.value
                              //     )) || {
                              //     value: "",
                              //     label:
                              //       translations["dropdown"].select[language],
                              //   }
                              // }
                              onChange={(selectedOption) =>
                                form.setFieldValue(
                                  field.name,
                                  selectedOption.value
                                )
                              }
                              maxMenuHeight={"120px"}
                              styles={{
                                input: (provided) => ({
                                  ...provided,
                                  color: isDarkMode ? "#ffffff" : "black", // Color of the text when typing
                                }),
                                control: (provided, state) => ({
                                  ...provided,
                                  backgroundColor: isDarkMode
                                    ? "transparent"
                                    : "white",
                                  border: state.isFocused
                                    ? "1px solid #80bdff"
                                    : isDarkMode
                                    ? "1px solid #495057"
                                    : "1px solid #dee2e6", // Adjust the border color for focus
                                  boxShadow: state.isFocused
                                    ? "0 0 0 0.2rem rgba(0, 123, 255, 0.25)"
                                    : "none", // Bootstrap's box shadow for focus
                                  borderRadius: ".45rem",
                                }),
                                valueContainer: (provided) => ({
                                  ...provided,
                                  padding: "0.18rem 0.55rem", // Bootstrap's padding for the value container
                                }),
                                indicatorSeparator: (provided) => ({
                                  ...provided,
                                  display: "none", // Hide the indicator separator
                                }),
                                dropdownIndicator: (provided) => ({
                                  ...provided,
                                  padding: "0.375rem 0.75rem", // Bootstrap's padding for the dropdown indicator
                                  color: isDarkMode ? "#ffffff" : "#868686",
                                }),
                                menu: (provided) => ({
                                  ...provided,
                                  color: isDarkMode ? "#ffffff" : "black",
                                  backgroundColor: isDarkMode
                                    ? "#1f2023"
                                    : "white",
                                  margin: "0", // Remove default margin
                                }),
                                placeholder: (provided) => ({
                                  ...provided,
                                  color: isDarkMode ? "#ffffff" : "#333333", // Specify your desired color for the placeholder
                                  // Additional styles for placeholder
                                }),
                                singleValue: (provided) => ({
                                  ...provided,
                                  color: isDarkMode ? "#ffffff" : "black",
                                }),
                                option: (provided, state) => ({
                                  ...provided,
                                  color: isDarkMode ? "#ffffff" : "black",
                                  backgroundColor: state.isHovered
                                    ? "#80bdff"
                                    : isDarkMode
                                    ? "#1f2023"
                                    : "white",
                                  ":hover": {
                                    backgroundColor: isDarkMode
                                      ? "#34DBB4"
                                      : "#34DBB4",
                                  },
                                }),
                              }}
                            />
                          )}
                        /> */}
                          <Field
                            name="address"
                            type="text"
                            className="form-control"
                            id="inputadddealership"
                            style={{
                              backgroundColor: isDarkMode ? "transparent" : "",
                              color: isDarkMode ? "#ffffff" : "#000000",
                              border: isDarkMode
                                ? "1px solid #495057"
                                : "1px solid #dee2e6",
                            }}
                            placeholder={
                              translations.quickCreationModal.address[language]
                            }
                          />
                          <ErrorMessage
                            name="address"
                            component="div"
                            className="error text-danger"
                          />
                        </div>
                      </div>
                      <div className="col-6">
                        <label for="inputadddealership" class="form-label">
                          {
                            translations.forms.formFields.conquestSection
                              .postalCode[language]
                          }
                        </label>
                        <div className="mb-3">
                          {/* <Field
                          name="state"
                          render={({ field, form }) => (
                            <Select
                              className="selectpicker"
                              aria-labelledby="dealership-name-quick"
                              // isClearable
                              // options={packageOptions}
                              placeholder={
                                translations["dropdown"].select[language]
                              }
                              isSearchable
                              // value={
                              //   (packageOptions &&
                              //     packageOptions.length > 0 &&
                              //     packageOptions.find(
                              //       (option) => option.value === field.value
                              //     )) || {
                              //     value: "",
                              //     label:
                              //       translations["dropdown"].select[language],
                              //   }
                              // }
                              onChange={(selectedOption) =>
                                form.setFieldValue(
                                  field.name,
                                  selectedOption.value
                                )
                              }
                              maxMenuHeight={"120px"}
                              styles={{
                                input: (provided) => ({
                                  ...provided,
                                  color: isDarkMode ? "#ffffff" : "black", // Color of the text when typing
                                }),
                                control: (provided, state) => ({
                                  ...provided,
                                  backgroundColor: isDarkMode
                                    ? "transparent"
                                    : "white",
                                  border: state.isFocused
                                    ? "1px solid #80bdff"
                                    : isDarkMode
                                    ? "1px solid #495057"
                                    : "1px solid #dee2e6", // Adjust the border color for focus
                                  boxShadow: state.isFocused
                                    ? "0 0 0 0.2rem rgba(0, 123, 255, 0.25)"
                                    : "none", // Bootstrap's box shadow for focus
                                  borderRadius: ".45rem",
                                }),
                                valueContainer: (provided) => ({
                                  ...provided,
                                  padding: "0.18rem 0.55rem", // Bootstrap's padding for the value container
                                }),
                                indicatorSeparator: (provided) => ({
                                  ...provided,
                                  display: "none", // Hide the indicator separator
                                }),
                                dropdownIndicator: (provided) => ({
                                  ...provided,
                                  padding: "0.375rem 0.75rem", // Bootstrap's padding for the dropdown indicator
                                  color: isDarkMode ? "#ffffff" : "#868686",
                                }),
                                menu: (provided) => ({
                                  ...provided,
                                  color: isDarkMode ? "#ffffff" : "black",
                                  backgroundColor: isDarkMode
                                    ? "#1f2023"
                                    : "white",
                                  margin: "0", // Remove default margin
                                }),
                                placeholder: (provided) => ({
                                  ...provided,
                                  color: isDarkMode ? "#ffffff" : "#333333", // Specify your desired color for the placeholder
                                  // Additional styles for placeholder
                                }),
                                singleValue: (provided) => ({
                                  ...provided,
                                  color: isDarkMode ? "#ffffff" : "black",
                                }),
                                option: (provided, state) => ({
                                  ...provided,
                                  color: isDarkMode ? "#ffffff" : "black",
                                  backgroundColor: state.isHovered
                                    ? "#80bdff"
                                    : isDarkMode
                                    ? "#1f2023"
                                    : "white",
                                  ":hover": {
                                    backgroundColor: isDarkMode
                                      ? "#34DBB4"
                                      : "#34DBB4",
                                  },
                                }),
                              }}
                            />
                          )}
                        /> */}
                          <Field
                            name="postal_code"
                            type="text"
                            className="form-control"
                            id="inputadddealership"
                            style={{
                              backgroundColor: isDarkMode ? "transparent" : "",
                              color: isDarkMode ? "#ffffff" : "#000000",
                              border: isDarkMode
                                ? "1px solid #495057"
                                : "1px solid #dee2e6",
                            }}
                            placeholder={
                              translations.forms.formFields.conquestSection
                                .postalCode[language]
                            }
                          />
                          <ErrorMessage
                            name="postal_code"
                            component="div"
                            className="error text-danger"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-6" style={{ paddingRight: "0px" }}>
                        <label for="inputadddealership" class="form-label">
                          {translations.quickCreationModal.timezone[language]}
                        </label>
                        <div className="mb-3">
                          {/* <Field
                          name="city"
                          render={({ field, form }) => (
                            <Select
                              className="selectpicker"
                              aria-labelledby="dealership-name-quick"
                              // isClearable
                              // options={packageOptions}
                              placeholder={
                                translations["dropdown"].select[language]
                              }
                              isSearchable
                              // value={
                              //   (packageOptions &&
                              //     packageOptions.length > 0 &&
                              //     packageOptions.find(
                              //       (option) => option.value === field.value
                              //     )) || {
                              //     value: "",
                              //     label:
                              //       translations["dropdown"].select[language],
                              //   }
                              // }
                              onChange={(selectedOption) =>
                                form.setFieldValue(
                                  field.name,
                                  selectedOption.value
                                )
                              }
                              maxMenuHeight={"120px"}
                              styles={{
                                input: (provided) => ({
                                  ...provided,
                                  color: isDarkMode ? "#ffffff" : "black", // Color of the text when typing
                                }),
                                control: (provided, state) => ({
                                  ...provided,
                                  backgroundColor: isDarkMode
                                    ? "transparent"
                                    : "white",
                                  border: state.isFocused
                                    ? "1px solid #80bdff"
                                    : isDarkMode
                                    ? "1px solid #495057"
                                    : "1px solid #dee2e6", // Adjust the border color for focus
                                  boxShadow: state.isFocused
                                    ? "0 0 0 0.2rem rgba(0, 123, 255, 0.25)"
                                    : "none", // Bootstrap's box shadow for focus
                                  borderRadius: ".45rem",
                                }),
                                valueContainer: (provided) => ({
                                  ...provided,
                                  padding: "0.18rem 0.55rem", // Bootstrap's padding for the value container
                                }),
                                indicatorSeparator: (provided) => ({
                                  ...provided,
                                  display: "none", // Hide the indicator separator
                                }),
                                dropdownIndicator: (provided) => ({
                                  ...provided,
                                  padding: "0.375rem 0.75rem", // Bootstrap's padding for the dropdown indicator
                                  color: isDarkMode ? "#ffffff" : "#868686",
                                }),
                                menu: (provided) => ({
                                  ...provided,
                                  color: isDarkMode ? "#ffffff" : "black",
                                  backgroundColor: isDarkMode
                                    ? "#1f2023"
                                    : "white",
                                  margin: "0", // Remove default margin
                                }),
                                placeholder: (provided) => ({
                                  ...provided,
                                  color: isDarkMode ? "#ffffff" : "#333333", // Specify your desired color for the placeholder
                                  // Additional styles for placeholder
                                }),
                                singleValue: (provided) => ({
                                  ...provided,
                                  color: isDarkMode ? "#ffffff" : "black",
                                }),
                                option: (provided, state) => ({
                                  ...provided,
                                  color: isDarkMode ? "#ffffff" : "black",
                                  backgroundColor: state.isHovered
                                    ? "#80bdff"
                                    : isDarkMode
                                    ? "#1f2023"
                                    : "white",
                                  ":hover": {
                                    backgroundColor: isDarkMode
                                      ? "#34DBB4"
                                      : "#34DBB4",
                                  },
                                }),
                              }}
                            />
                          )}
                        /> */}
                          <Field
                            name="timezone"
                            type="text"
                            className="form-control"
                            id="inputadddealership"
                            style={{
                              backgroundColor: isDarkMode ? "transparent" : "",
                              color: isDarkMode ? "#ffffff" : "#000000",
                              border: isDarkMode
                                ? "1px solid #495057"
                                : "1px solid #dee2e6",
                            }}
                            placeholder={
                              translations.quickCreationModal.timezone[language]
                            }
                          />
                          <ErrorMessage
                            name="timezone"
                            component="div"
                            className="error text-danger"
                          />
                        </div>
                      </div>
                      <div className="col-6">
                        <label for="inputadddealership" class="form-label">
                          {translations.quickCreationModal.phoneNumber[language]}
                        </label>
                        <div className="mb-3">
                          {/* <Field
                          name="state"
                          render={({ field, form }) => (
                            <Select
                              className="selectpicker"
                              aria-labelledby="dealership-name-quick"
                              // isClearable
                              // options={packageOptions}
                              placeholder={
                                translations["dropdown"].select[language]
                              }
                              isSearchable
                              // value={
                              //   (packageOptions &&
                              //     packageOptions.length > 0 &&
                              //     packageOptions.find(
                              //       (option) => option.value === field.value
                              //     )) || {
                              //     value: "",
                              //     label:
                              //       translations["dropdown"].select[language],
                              //   }
                              // }
                              onChange={(selectedOption) =>
                                form.setFieldValue(
                                  field.name,
                                  selectedOption.value
                                )
                              }
                              maxMenuHeight={"120px"}
                              styles={{
                                input: (provided) => ({
                                  ...provided,
                                  color: isDarkMode ? "#ffffff" : "black", // Color of the text when typing
                                }),
                                control: (provided, state) => ({
                                  ...provided,
                                  backgroundColor: isDarkMode
                                    ? "transparent"
                                    : "white",
                                  border: state.isFocused
                                    ? "1px solid #80bdff"
                                    : isDarkMode
                                    ? "1px solid #495057"
                                    : "1px solid #dee2e6", // Adjust the border color for focus
                                  boxShadow: state.isFocused
                                    ? "0 0 0 0.2rem rgba(0, 123, 255, 0.25)"
                                    : "none", // Bootstrap's box shadow for focus
                                  borderRadius: ".45rem",
                                }),
                                valueContainer: (provided) => ({
                                  ...provided,
                                  padding: "0.18rem 0.55rem", // Bootstrap's padding for the value container
                                }),
                                indicatorSeparator: (provided) => ({
                                  ...provided,
                                  display: "none", // Hide the indicator separator
                                }),
                                dropdownIndicator: (provided) => ({
                                  ...provided,
                                  padding: "0.375rem 0.75rem", // Bootstrap's padding for the dropdown indicator
                                  color: isDarkMode ? "#ffffff" : "#868686",
                                }),
                                menu: (provided) => ({
                                  ...provided,
                                  color: isDarkMode ? "#ffffff" : "black",
                                  backgroundColor: isDarkMode
                                    ? "#1f2023"
                                    : "white",
                                  margin: "0", // Remove default margin
                                }),
                                placeholder: (provided) => ({
                                  ...provided,
                                  color: isDarkMode ? "#ffffff" : "#333333", // Specify your desired color for the placeholder
                                  // Additional styles for placeholder
                                }),
                                singleValue: (provided) => ({
                                  ...provided,
                                  color: isDarkMode ? "#ffffff" : "black",
                                }),
                                option: (provided, state) => ({
                                  ...provided,
                                  color: isDarkMode ? "#ffffff" : "black",
                                  backgroundColor: state.isHovered
                                    ? "#80bdff"
                                    : isDarkMode
                                    ? "#1f2023"
                                    : "white",
                                  ":hover": {
                                    backgroundColor: isDarkMode
                                      ? "#34DBB4"
                                      : "#34DBB4",
                                  },
                                }),
                              }}
                            />
                          )}
                        /> */}
                          <Field
                            name="phone_number"
                            type="text"
                            className="form-control"
                            id="inputadddealership"
                            style={{
                              backgroundColor: isDarkMode ? "transparent" : "",
                              color: isDarkMode ? "#ffffff" : "#000000",
                              border: isDarkMode
                                ? "1px solid #495057"
                                : "1px solid #dee2e6",
                            }}
                            placeholder={
                              translations.quickCreationModal.phoneNumber[
                              language
                              ]
                            }
                          />
                          <ErrorMessage
                            name="phone_number"
                            component="div"
                            className="error text-danger"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-6" style={{ paddingRight: "0px" }}>
                        <label class="form-label">
                          {" "}
                          {translations.quickCreationModal.brand[language]}
                        </label>
                        <div className="mb-3">
                          <div class="">
                            <div>
                              <Select
                                name="brand_id"
                                className="selectpicker"
                                maxMenuHeight={"85px"}
                                value={selected}
                                onChange={(selectedOption) => {
                                  setSelected({
                                    value: selectedOption.value,
                                    label: selectedOption.label,
                                  });
                                  setValues({
                                    ...values,
                                    brand_id: selectedOption.value,
                                  });
                                }}
                                aria-labelledby="dealership-name-quick"
                                options={brandOptions}
                                placeholder={
                                  translations["dropdown"].select[language]
                                }
                                isSearchable
                                styles={{
                                  input: (provided) => ({
                                    ...provided,
                                    color: isDarkMode ? "#ffffff" : "black", // Color of the text when typing
                                  }),
                                  control: (provided, state) => ({
                                    ...provided,
                                    color: isDarkMode ? "#ffffff" : "black",
                                    backgroundColor: isDarkMode
                                      ? "transparent"
                                      : "white",
                                    border: state.isFocused
                                      ? "1px solid #80bdff"
                                      : isDarkMode
                                        ? "1px solid #495057"
                                        : "1px solid #dee2e6", // Adjust the border color for focus
                                    boxShadow: state.isFocused
                                      ? "0 0 0 0.2rem rgba(0, 123, 255, 0.25)"
                                      : "none", // Bootstrap's box shadow for focus
                                    borderRadius: ".45rem",
                                  }),
                                  valueContainer: (provided) => ({
                                    ...provided,
                                    padding: "0.18rem 0.55rem", // Bootstrap's padding for the value container
                                  }),
                                  indicatorSeparator: (provided) => ({
                                    ...provided,
                                    display: "none", // Hide the indicator separator
                                  }),
                                  dropdownIndicator: (provided) => ({
                                    ...provided,
                                    padding: "0.375rem 0.75rem", // Bootstrap's padding for the dropdown indicator
                                    color: isDarkMode ? "#ffffff" : "#868686",
                                  }),
                                  menu: (provided) => ({
                                    ...provided,
                                    margin: "0", // Remove default margin
                                    color: isDarkMode ? "#ffffff" : "black",
                                    backgroundColor: isDarkMode
                                      ? "#1f2023"
                                      : "white",
                                  }),
                                  placeholder: (provided) => ({
                                    ...provided,
                                    color: isDarkMode ? "#ffffff" : "#333333", // Specify your desired color for the placeholder
                                    // Additional styles for placeholder
                                  }),
                                  singleValue: (provided) => ({
                                    ...provided,
                                    color: isDarkMode ? "#ffffff" : "black",
                                  }),
                                  option: (provided, state) => ({
                                    ...provided,
                                    color: isDarkMode ? "#ffffff" : "black",
                                    backgroundColor: state.isHovered
                                      ? "#80bdff"
                                      : isDarkMode
                                        ? "#1f2023"
                                        : "white",
                                    ":hover": {
                                      backgroundColor: isDarkMode
                                        ? "#48cae4"
                                        : "#48cae4",
                                    },
                                  }),
                                }}
                              />
                              <ErrorMessage
                                name="brand_id"
                                component="div"
                                className="error text-danger"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-6" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <div className="col-10">
                          <label for="inputadddealership" class="form-label">
                            {translations.quickCreationModal.group[language]}
                          </label>
                          <div className="mb-3">
                            <Field
                              name="group_id"
                              render={({ field, form }) => (
                                <Select
                                  className="selectpicker"
                                  aria-labelledby="dealership-name-quick"
                                  // isClearable
                                  options={groupList}
                                  placeholder={
                                    translations["dropdown"].select[language]
                                  }
                                  isSearchable
                                  // value={
                                  //   (packageOptions &&
                                  //     packageOptions.length > 0 &&
                                  //     packageOptions.find(
                                  //       (option) => option.value === field.value
                                  //     )) || {
                                  //     value: "",
                                  //     label:
                                  //       translations["dropdown"].select[language],
                                  //   }
                                  // }
                                  value={
                                    (groupList &&
                                      groupList.length > 0 &&
                                      groupList.find(
                                        (option) =>
                                          option.value === selectedGroup
                                      )) || {
                                      value: "",
                                      label:
                                        translations["dropdown"].select[
                                        language
                                        ],
                                    }
                                  }
                                  // value={
                                  //   groupList?.find(
                                  //     (option) => String(option.value) === String(field.value)
                                  //   ) || null
                                  // }
                                  onChange={(selectedOption) => {
                                    form.setFieldValue(
                                      field.name,
                                      selectedOption.value
                                    )
                                    setSelectedGroup(selectedOption.value);
                                  }

                                  }
                                  maxMenuHeight={"120px"}
                                  styles={{
                                    input: (provided) => ({
                                      ...provided,
                                      color: isDarkMode ? "#ffffff" : "black", // Color of the text when typing
                                    }),
                                    control: (provided, state) => ({
                                      ...provided,
                                      backgroundColor: isDarkMode
                                        ? "transparent"
                                        : "white",
                                      border: state.isFocused
                                        ? "1px solid #80bdff"
                                        : isDarkMode
                                          ? "1px solid #495057"
                                          : "1px solid #dee2e6", // Adjust the border color for focus
                                      boxShadow: state.isFocused
                                        ? "0 0 0 0.2rem rgba(0, 123, 255, 0.25)"
                                        : "none", // Bootstrap's box shadow for focus
                                      borderRadius: ".45rem",
                                    }),
                                    valueContainer: (provided) => ({
                                      ...provided,
                                      padding: "0.18rem 0.55rem", // Bootstrap's padding for the value container
                                    }),
                                    indicatorSeparator: (provided) => ({
                                      ...provided,
                                      display: "none", // Hide the indicator separator
                                    }),
                                    dropdownIndicator: (provided) => ({
                                      ...provided,
                                      padding: "0.375rem 0.75rem", // Bootstrap's padding for the dropdown indicator
                                      color: isDarkMode ? "#ffffff" : "#868686",
                                    }),
                                    menu: (provided) => ({
                                      ...provided,
                                      color: isDarkMode ? "#ffffff" : "black",
                                      backgroundColor: isDarkMode
                                        ? "#1f2023"
                                        : "white",
                                      margin: "0", // Remove default margin
                                    }),
                                    placeholder: (provided) => ({
                                      ...provided,
                                      color: isDarkMode ? "#ffffff" : "#333333", // Specify your desired color for the placeholder
                                      // Additional styles for placeholder
                                    }),
                                    singleValue: (provided) => ({
                                      ...provided,
                                      color: isDarkMode ? "#ffffff" : "black",
                                    }),
                                    option: (provided, state) => ({
                                      ...provided,
                                      color: isDarkMode ? "#ffffff" : "black",
                                      backgroundColor: state.isHovered
                                        ? "#80bdff"
                                        : isDarkMode
                                          ? "#1f2023"
                                          : "white",
                                      ":hover": {
                                        backgroundColor: isDarkMode
                                          ? "#34DBB4"
                                          : "#34DBB4",
                                      },
                                    }),
                                  }}
                                />
                              )}
                            />
                            {/* <Field
                          name="group_id"
                          type="text"
                          className="form-control"
                          id="inputadddealership"
                          style={{
                            backgroundColor: isDarkMode ? "transparent" : "",
                            color: isDarkMode ? "#ffffff" : "#000000",
                            border: isDarkMode
                              ? "1px solid #495057"
                              : "1px solid #dee2e6",
                          }}
                          placeholder={
                            translations.quickCreationModal.group[language]
                          }
                        /> */}
                            <ErrorMessage
                              name="group_id"
                              component="div"
                              className="error text-danger"
                            />
                          </div>

                        </div>
                        <div class="col-2 mt-3">
                          <div class="">
                            {/* <button
                            type="button"
                            class="client-btn btn-success"
                            // data-bs-dismiss="modal"
                            // onClick={() => {
                            
                            //   var createModal = new window.bootstrap.Modal(
                            //     document.getElementById("groupModal")
                            //   );
                            //   createModal.show();
                              
                            // }}
                         
                          >
                            <i class="bi bi-plus-circle"></i>{" "}
                            {
                              translations["quickCreationModal"].addBtn[
                              language
                              ]
                            }
                          </button> */}
                            <button
                              type="button"
                              class="client-btn btn-success"
                              onClick={openCustomModal}
                            >
                              <i class="bi bi-plus-circle"></i>{" "}
                              {
                                translations["quickCreationModal"].addBtn[
                                language
                                ]
                              }
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-6" style={{ paddingRight: "0px" }}>
                        <label class="form-label">
                          {" "}
                          {translations.forms.formFields.representative[language]}
                        </label>
                        <div className="mb-3">
                          <Field
                            name="representative_id"
                            render={({ field, form }) => (
                              <Select
                                className="selectpicker"
                                aria-labelledby="dealership-name-quick"
                                // isClearable
                                options={repOptions}
                                placeholder={
                                  translations["dropdown"].select[language]
                                }
                                isSearchable
                                value={
                                  (repOptions &&
                                    repOptions.length > 0 &&
                                    repOptions.find(
                                      (option) => option.value === field.value
                                    )) || {
                                    value: "",
                                    label:
                                      translations["dropdown"].select[language],
                                  }
                                }
                                onChange={(selectedOption) =>
                                  form.setFieldValue(
                                    field.name,
                                    selectedOption.value
                                  )
                                }
                                maxMenuHeight={"120px"}
                                styles={{
                                  input: (provided) => ({
                                    ...provided,
                                    color: isDarkMode ? "#ffffff" : "black", // Color of the text when typing
                                  }),
                                  control: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: isDarkMode
                                      ? "transparent"
                                      : "white",
                                    border: state.isFocused
                                      ? "1px solid #80bdff"
                                      : isDarkMode
                                        ? "1px solid #495057"
                                        : "1px solid #dee2e6", // Adjust the border color for focus
                                    boxShadow: state.isFocused
                                      ? "0 0 0 0.2rem rgba(0, 123, 255, 0.25)"
                                      : "none", // Bootstrap's box shadow for focus
                                    borderRadius: ".45rem",
                                  }),
                                  valueContainer: (provided) => ({
                                    ...provided,
                                    padding: "0.18rem 0.55rem", // Bootstrap's padding for the value container
                                  }),
                                  indicatorSeparator: (provided) => ({
                                    ...provided,
                                    display: "none", // Hide the indicator separator
                                  }),
                                  dropdownIndicator: (provided) => ({
                                    ...provided,
                                    padding: "0.375rem 0.75rem", // Bootstrap's padding for the dropdown indicator
                                    color: isDarkMode ? "#ffffff" : "#868686",
                                  }),
                                  menu: (provided) => ({
                                    ...provided,
                                    color: isDarkMode ? "#ffffff" : "black",
                                    backgroundColor: isDarkMode
                                      ? "#1f2023"
                                      : "white",
                                    margin: "0", // Remove default margin
                                  }),
                                  placeholder: (provided) => ({
                                    ...provided,
                                    color: isDarkMode ? "#ffffff" : "#333333", // Specify your desired color for the placeholder
                                    // Additional styles for placeholder
                                  }),
                                  singleValue: (provided) => ({
                                    ...provided,
                                    color: isDarkMode ? "#ffffff" : "black",
                                  }),
                                  option: (provided, state) => ({
                                    ...provided,
                                    color: isDarkMode ? "#ffffff" : "black",
                                    backgroundColor: state.isHovered
                                      ? "#80bdff"
                                      : isDarkMode
                                        ? "#1f2023"
                                        : "white",
                                    ":hover": {
                                      backgroundColor: isDarkMode
                                        ? "#48cae4"
                                        : "#48cae4",
                                    },
                                  }),
                                }}
                              />
                            )}
                          />
                          <ErrorMessage
                            name="representative_id"
                            component="div"
                            className="error text-danger"
                          />
                        </div>
                      </div>
                      <div className="col-6">
                        <label for="inputadddealership" class="form-label">
                          {
                            translations.quickCreationModal.primaryContact[
                            language
                            ]
                          }
                        </label>
                        <div className="mb-3">
                          {/* <Field
                          name="state"
                          render={({ field, form }) => (
                            <Select
                              className="selectpicker"
                              aria-labelledby="dealership-name-quick"
                              // isClearable
                              // options={packageOptions}
                              placeholder={
                                translations["dropdown"].select[language]
                              }
                              isSearchable
                              // value={
                              //   (packageOptions &&
                              //     packageOptions.length > 0 &&
                              //     packageOptions.find(
                              //       (option) => option.value === field.value
                              //     )) || {
                              //     value: "",
                              //     label:
                              //       translations["dropdown"].select[language],
                              //   }
                              // }
                              onChange={(selectedOption) =>
                                form.setFieldValue(
                                  field.name,
                                  selectedOption.value
                                )
                              }
                              maxMenuHeight={"120px"}
                              styles={{
                                input: (provided) => ({
                                  ...provided,
                                  color: isDarkMode ? "#ffffff" : "black", // Color of the text when typing
                                }),
                                control: (provided, state) => ({
                                  ...provided,
                                  backgroundColor: isDarkMode
                                    ? "transparent"
                                    : "white",
                                  border: state.isFocused
                                    ? "1px solid #80bdff"
                                    : isDarkMode
                                    ? "1px solid #495057"
                                    : "1px solid #dee2e6", // Adjust the border color for focus
                                  boxShadow: state.isFocused
                                    ? "0 0 0 0.2rem rgba(0, 123, 255, 0.25)"
                                    : "none", // Bootstrap's box shadow for focus
                                  borderRadius: ".45rem",
                                }),
                                valueContainer: (provided) => ({
                                  ...provided,
                                  padding: "0.18rem 0.55rem", // Bootstrap's padding for the value container
                                }),
                                indicatorSeparator: (provided) => ({
                                  ...provided,
                                  display: "none", // Hide the indicator separator
                                }),
                                dropdownIndicator: (provided) => ({
                                  ...provided,
                                  padding: "0.375rem 0.75rem", // Bootstrap's padding for the dropdown indicator
                                  color: isDarkMode ? "#ffffff" : "#868686",
                                }),
                                menu: (provided) => ({
                                  ...provided,
                                  color: isDarkMode ? "#ffffff" : "black",
                                  backgroundColor: isDarkMode
                                    ? "#1f2023"
                                    : "white",
                                  margin: "0", // Remove default margin
                                }),
                                placeholder: (provided) => ({
                                  ...provided,
                                  color: isDarkMode ? "#ffffff" : "#333333", // Specify your desired color for the placeholder
                                  // Additional styles for placeholder
                                }),
                                singleValue: (provided) => ({
                                  ...provided,
                                  color: isDarkMode ? "#ffffff" : "black",
                                }),
                                option: (provided, state) => ({
                                  ...provided,
                                  color: isDarkMode ? "#ffffff" : "black",
                                  backgroundColor: state.isHovered
                                    ? "#80bdff"
                                    : isDarkMode
                                    ? "#1f2023"
                                    : "white",
                                  ":hover": {
                                    backgroundColor: isDarkMode
                                      ? "#34DBB4"
                                      : "#34DBB4",
                                  },
                                }),
                              }}
                            />
                          )}
                        /> */}
                          <Field
                            name="primary_contact"
                            type="text"
                            className="form-control"
                            id="inputadddealership"
                            style={{
                              backgroundColor: isDarkMode ? "transparent" : "",
                              color: isDarkMode ? "#ffffff" : "#000000",
                              border: isDarkMode
                                ? "1px solid #495057"
                                : "1px solid #dee2e6",
                            }}
                            placeholder={
                              translations.quickCreationModal.primaryContact[
                              language
                              ]
                            }
                          />
                          <ErrorMessage
                            name="primary_contact"
                            component="div"
                            className="error text-danger"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-6">
                        <label for="inputadddealership" class="form-label">
                          {translations.quickCreationModal.crm[language]}
                        </label>
                        <div className="mb-3">
                          {/* <Field
                          name="state"
                          render={({ field, form }) => (
                            <Select
                              className="selectpicker"
                              aria-labelledby="dealership-name-quick"
                              // isClearable
                              // options={packageOptions}
                              placeholder={
                                translations["dropdown"].select[language]
                              }
                              isSearchable
                              // value={
                              //   (packageOptions &&
                              //     packageOptions.length > 0 &&
                              //     packageOptions.find(
                              //       (option) => option.value === field.value
                              //     )) || {
                              //     value: "",
                              //     label:
                              //       translations["dropdown"].select[language],
                              //   }
                              // }
                              onChange={(selectedOption) =>
                                form.setFieldValue(
                                  field.name,
                                  selectedOption.value
                                )
                              }
                              maxMenuHeight={"120px"}
                              styles={{
                                input: (provided) => ({
                                  ...provided,
                                  color: isDarkMode ? "#ffffff" : "black", // Color of the text when typing
                                }),
                                control: (provided, state) => ({
                                  ...provided,
                                  backgroundColor: isDarkMode
                                    ? "transparent"
                                    : "white",
                                  border: state.isFocused
                                    ? "1px solid #80bdff"
                                    : isDarkMode
                                    ? "1px solid #495057"
                                    : "1px solid #dee2e6", // Adjust the border color for focus
                                  boxShadow: state.isFocused
                                    ? "0 0 0 0.2rem rgba(0, 123, 255, 0.25)"
                                    : "none", // Bootstrap's box shadow for focus
                                  borderRadius: ".45rem",
                                }),
                                valueContainer: (provided) => ({
                                  ...provided,
                                  padding: "0.18rem 0.55rem", // Bootstrap's padding for the value container
                                }),
                                indicatorSeparator: (provided) => ({
                                  ...provided,
                                  display: "none", // Hide the indicator separator
                                }),
                                dropdownIndicator: (provided) => ({
                                  ...provided,
                                  padding: "0.375rem 0.75rem", // Bootstrap's padding for the dropdown indicator
                                  color: isDarkMode ? "#ffffff" : "#868686",
                                }),
                                menu: (provided) => ({
                                  ...provided,
                                  color: isDarkMode ? "#ffffff" : "black",
                                  backgroundColor: isDarkMode
                                    ? "#1f2023"
                                    : "white",
                                  margin: "0", // Remove default margin
                                }),
                                placeholder: (provided) => ({
                                  ...provided,
                                  color: isDarkMode ? "#ffffff" : "#333333", // Specify your desired color for the placeholder
                                  // Additional styles for placeholder
                                }),
                                singleValue: (provided) => ({
                                  ...provided,
                                  color: isDarkMode ? "#ffffff" : "black",
                                }),
                                option: (provided, state) => ({
                                  ...provided,
                                  color: isDarkMode ? "#ffffff" : "black",
                                  backgroundColor: state.isHovered
                                    ? "#80bdff"
                                    : isDarkMode
                                    ? "#1f2023"
                                    : "white",
                                  ":hover": {
                                    backgroundColor: isDarkMode
                                      ? "#34DBB4"
                                      : "#34DBB4",
                                  },
                                }),
                              }}
                            />
                          )}
                        /> */}
                          <Field
                            name="crm_link"
                            type="text"
                            className="form-control"
                            id="inputadddealership"
                            style={{
                              backgroundColor: isDarkMode ? "transparent" : "",
                              color: isDarkMode ? "#ffffff" : "#000000",
                              border: isDarkMode
                                ? "1px solid #495057"
                                : "1px solid #dee2e6",
                            }}
                            placeholder={
                              translations.quickCreationModal.crm[language]
                            }
                          />
                          {/* <button
                          type="button"
                          className="admin-btn btn btn-primary"
                          id="add-dealership"
                          disabled={!values.crm_link}
                          onClick={() => {
                            if (values.crm_link) {
                              const url = `https://crm.zoho.com/crm/org27297444/tab/Accounts/${values.crm_link}`;
                              window.open(url, "_blank");
                            }
                          }}
                        >
                          CRM
                        </button> */}

                          <ErrorMessage
                            name="crm_link"
                            component="div"
                            className="error text-danger"
                          />

                        </div>
                      </div>
                      <div className="col-6">
                        <label for="activeX_key" class="form-label">
                          {
                            translations.quickCreationModal.activeX_key[
                            language
                            ]
                          }
                        </label>
                        <div className="mb-3">
                          <Field
                            name="activeX_key"
                            type="text"
                            className="form-control"
                            id="activeX_key"
                            style={{
                              backgroundColor: isDarkMode ? "transparent" : "",
                              color: isDarkMode ? "#ffffff" : "#000000",
                              border: isDarkMode
                                ? "1px solid #495057"
                                : "1px solid #dee2e6",
                            }}
                            placeholder={
                              translations.quickCreationModal.activeX_key[
                              language
                              ]
                            }
                          />
                          <ErrorMessage
                            name="activeX_key"
                            component="div"
                            className="error text-danger"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-6">
                        <label htmlFor="activeX_first_name" className="form-label">
                          {translations.commonFields.firstName[language]}
                        </label>
                        <div className="mb-3">
                          <Field
                            name="activeX_first_name"
                            type="text"
                            className="form-control"
                            id="activeX_first_name"
                            style={{
                              backgroundColor: isDarkMode ? "transparent" : "",
                              color: isDarkMode ? "#ffffff" : "#000000",
                              border: isDarkMode ? "1px solid #495057" : "1px solid #dee2e6",
                            }}
                            placeholder={translations.commonFields.firstName[language]}
                          />
                          <ErrorMessage name="activeX_first_name" component="div" className="error text-danger" />
                        </div>
                      </div>

                      <div className="col-6">
                        <label htmlFor="activeX_last_name" className="form-label">
                          {translations.commonFields.lastName[language]}
                        </label>
                        <div className="mb-3">
                          <Field
                            name="activeX_last_name"
                            type="text"
                            className="form-control"
                            id="activeX_last_name"
                            style={{
                              backgroundColor: isDarkMode ? "transparent" : "",
                              color: isDarkMode ? "#ffffff" : "#000000",
                              border: isDarkMode ? "1px solid #495057" : "1px solid #dee2e6",
                            }}
                            placeholder={translations.commonFields.lastName[language]}
                          />
                          <ErrorMessage name="activeX_last_name" component="div" className="error text-danger" />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col">
                        <Dropzone
                          // disabled={!editable}
                          style={{
                            backgroundColor: "#ced4da66",
                          }}
                          multiple={false}
                          accept=".png, .jpeg, .jpg, .webp"
                          onDrop={(acceptedFiles) => {
                            // console.log(acceptedFiles)
                            if (acceptedFiles.length > 0) {
                              setValues({ ...values, logo: acceptedFiles[0] });
                            }
                          }}
                        >
                          {({ getRootProps, getInputProps }) => (
                            <div className="client-form-row w-100">
                              <div className="w-100">
                                <label
                                  htmlFor="logo"
                                  className="pb-3"
                                  style={{
                                    color: isDarkMode ? "#33dbb4" : "",
                                    fontSize: "20px",
                                    fontWeight: 600,
                                  }} /*class="form-label"*/
                                >
                                  {translations.quickCreationModal.logo[language]}
                                </label>

                                <div
                                  {...getRootProps()}
                                  role="presentation"
                                  tabIndex="0"
                                  style={{
                                    background: "rgb(231, 236, 239)",
                                    // backgroundImage: `url(${URL.createObjectURL(values.logo)})`,
                                    // backgroundSize: "cover",
                                    // backgroundPosition: "center",
                                    padding: "25px 0px",
                                    borderRadius: "0.375rem",
                                    height: "180px",
                                    display: "flex",
                                    alignContent: "center",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    cursor: "pointer",
                                  }}
                                >
                                  <input
                                    {...getInputProps()}
                                    type="file"
                                    accept=".png, .jpeg, .jpg, .webp"
                                  />
                                  <div className="client-file-input">
                                    <p
                                      style={{
                                        textAlign: "center",
                                        fontSize: "15px",
                                        fontWeight: 700,
                                        marginBottom: "30px",
                                        marginTop: "20px",
                                      }}
                                    >
                                      {
                                        translations.quickCreationModal.logo2[
                                        language
                                        ]
                                      }
                                    </p>
                                    <div className="pb-5">
                                      <i
                                        className="bi bi-file-earmark-arrow-up-fill"
                                        style={{
                                          border: "10px dashed #babec1",
                                          padding: "15px 100px",
                                          color: "#babec1",
                                          borderRadius: "0.375rem",
                                          fontSize: "40pt",
                                          marginTop: "10px",
                                        }}
                                      ></i>
                                    </div>
                                  </div>
                                </div>
                                {values.logo && (
                                  <div>
                                    <div className="d-flex gap-3 align-items-center ">
                                      <div
                                        className="d-flex gap-1 py-3 align-items-center"
                                        style={{ position: "relative" }}
                                      >
                                        <i
                                          className="bi bi-x-circle"
                                          onClick={() =>
                                            setValues({ ...values, logo: "" })
                                          }
                                          style={{
                                            position: "absolute",
                                            top: "16px",
                                            right: "4px",
                                            color: "red",
                                            cursor: "pointer",
                                            fontSize: "12px",
                                          }}
                                        ></i>
                                        <img
                                          className=""
                                          width={"65px"}
                                          height={"60px"}
                                          src={URL.createObjectURL(values.logo)}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                )}
                                <ErrorMessage
                                  name="logo"
                                  component="div"
                                  className="error text-danger"
                                />
                              </div>
                            </div>
                          )}
                        </Dropzone>
                      </div>
                    </div>
                  </div>
                  <div
                    class="modal-footer"
                    id="modalfooter"
                    style={{
                      borderTop: isDarkMode
                        ? "1px solid #495057"
                        : "1px solid #dee2e6",
                    }}
                  >
                    <button
                      type="submit"
                      class="admin-btn btn btn-primary"
                      id="add-dealership"

                    // data-bs-toggle="modal"
                    // data-bs-target="#modalQuickAdd"
                    >
                      {loading
                        ? translations["commonFields"].addingBtn[language]
                        : translations["commonFields"].addBtn[language]}
                    </button>
                    <button
                      id="closebtn3"
                      type="button"
                      class="btn btn-secondary"
                      data-bs-dismiss="modal"
                      // data-bs-toggle={quickAdd ? "modal" : ""}
                      // data-bs-target={quickAdd ? "#modalQuickAdd" : ""}
                      onClick={() => {
                        resetForm();
                        setValues({
                          name: "",
                          country: "",
                          state: "",
                          city: "",
                          address: "",
                          postal_code: "",
                          timezone: "",
                          phone_number: "",
                          primary_contact: "",
                          activeX_key: "",
                          group_id: "",
                          representative_id: "",
                          brand_id: "",
                          logo: "",
                          crm_link: "",
                        });
                        setSelected("");
                      }}
                    >
                      {translations["commonFields"].closeBtn[language]}
                    </button>
                    {/* <br />
                  <div
                    class="alert alert-danger d-flex align-items-center invisible"
                    id="clientFormAlert"
                    role="alert"
                  >
                    <div id="clientFormAlertText"></div>
                  </div> */}
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
        {loading && <Loader />}
      </div>

      <CreateGroup
        isDarkMode={isDarkMode}
        groupList={groupList}
        setGroupList={setGroupList}
        setSelectedGroup={setSelectedGroup}
        isOpen={isCreateGroupOpen}
        onClose={closeCustomModal}
        bootstrapModalId="myModalCon"
      />
    </>

  );
};

export default AddDealershipModal;
